'use client'

import {
  BundleTransactionModel,
  createBundleTransaction,
  CreateBundleTransactionArgs,
  transformBundleInquiry,
  transformBundleTransaction,
  createBundleInquiry as createBundleInquiryRequest,
} from '@marketplace-web/bundles/items-bundle-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

export const useCreateBundleInquiry = () => {
  const isWebMessagingSvcFSEnabled = useFeatureSwitch('web_messaging_svc')

  const createBundleInquiry = async ({
    selectedItemIds,
    bundleTrackingId,
    bundleShippingType,
    receiverId,
  }: CreateBundleTransactionArgs & {
    receiverId: string | number
  }): Promise<BundleTransactionModel | null> => {
    if (isWebMessagingSvcFSEnabled) {
      const response = await createBundleInquiryRequest({
        itemIds: selectedItemIds.map(id => id.toString()),
        receiverId: receiverId.toString(),
      })

      if ('errors' in response) return null

      return transformBundleInquiry(response)
    }

    const response = await createBundleTransaction({
      selectedItemIds,
      bundleTrackingId,
      bundleShippingType,
    })

    if ('errors' in response) return null

    return transformBundleTransaction(response.transaction)
  }

  return { createBundleInquiry }
}

export default useCreateBundleInquiry
